import React, { useState } from "react";
import { MdPowerSettingsNew } from "react-icons/md";

const API = process.env.REACT_APP_API_URL;

export default function DevicePowerButton({ patientId, isDeviceOnline = true }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function handleToggle() {
    if (!isDeviceOnline || pending) return;

    setPending(true);
    setError("");

    try {
      const res = await fetch(`${API}/patients/${patientId}/device-power`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "toggle" }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.error || "Gerätesteuerung fehlgeschlagen.");
      }
    } catch (e) {
      setError(e?.message || "Gerätesteuerung fehlgeschlagen.");
    } finally {
      setPending(false);
    }
  }

  const title = isDeviceOnline ? "Gerät ein-/ausschalten" : "Gerät offline";

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleToggle}
        disabled={!isDeviceOnline || pending}
        title={title}
        aria-label={title}
        className={[
          "inline-flex h-9 w-9 items-center justify-center rounded-lg border text-base shadow-sm transition",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "border-gray-200 bg-white text-gray-700 hover:bg-gray-50",
          pending ? "animate-pulse" : "",
        ].join(" ")}
      >
        <MdPowerSettingsNew />
      </button>
      {error && (
        <div className="absolute right-0 top-full z-10 mt-2 w-56 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-right text-xs text-red-800 shadow-sm">
          {error}
        </div>
      )}
    </div>
  );
}
